import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import Contact from "../../components/contactSection/contact";
import Internships from "../../components/allInternships/internships";

import BgImage from "../../images/internships/hero-bg1.png";
import HeroSection from "../../components/heroSection/hero";
import { getAllInternships } from "../../services/internships";
import { contactLink } from "../../common/routes";

function AllInternshipsPage() {
  const ContactText = "Not sure which domain is right for you";
  const ContactButtonText = "Talk to our counsellor";

  var [designInternships, setDesignInternships] = useState([]);
  var [developmentInternships, setDevelopmentInternships] = useState([]);
  var [marketingInternships, setMarketingInternships] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getInternships();
  }, []);

  async function getInternships() {
    await getAllInternships()
      .then((data) => {
        setDesignInternships(data.design);
        setDevelopmentInternships(data.development);
        setMarketingInternships(data.marketing);
      })
      .catch((error) => console.log(error));
  }

  return (
    <Box>
      <HeroSection heroBgImage={BgImage} text={"Internships"} />
      {designInternships.length !== 0 ? (
        <Internships
          title={"Design Internships"}
          internshipsData={designInternships}
        />
      ) : (
        ""
      )}
      {developmentInternships.length !== 0 ? (
        <Internships
          title={"Development Internships"}
          internshipsData={developmentInternships}
          colorBackground={"#EAEEF2"}
        />
      ) : (
        ""
      )}
      {marketingInternships.length !== 0 ? (
        <Internships
          title={"Marketing Internships"}
          internshipsData={marketingInternships}
        />
      ) : (
        ""
      )}
      <Contact text={ContactText} buttonText={ContactButtonText} url={contactLink} />
    </Box>
  );
}

export default AllInternshipsPage;
